import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable()
export class AppErrorMessagesService {
  createMessages(control: AbstractControl): { key: string; translate: boolean; params: { [param: string]: any } }[] {
    if (!control.errors) {
      return [];
    }
    const objectKeys = Object.keys(control.errors);

    return objectKeys.map(key => {
      const subkeys = Object.keys(control.errors[key]);
      // If the subproperty is an object, the subproperty has to be the error

      if (subkeys.length === 1 && typeof control.errors[key][subkeys[0]] === 'object') {
        return {
          key: `i18n.validation.${key}.${subkeys[0]}`,
          translate: true,
          params: control.errors[key][subkeys[0]]
        };
      }

      if (subkeys.length > 0 && control.errors[key].requiredLength) {
        return {
          key: `i18n.validation.${key}.requiredLength`,
          translate: true,
          params: control.errors[key][subkeys[0]]
        };
      }

      if (subkeys.length > 0 && typeof (control.errors[key].min) === 'number') {
        return {
          key: `i18n.validation.${key}`,
          translate: true,
          params: control.errors[key][subkeys[0]]
        };
      }

      if (subkeys.length > 0 && typeof (control.errors[key].max) === 'number') {
        return {
          key: `i18n.validation.${key}`,
          translate: true,
          params: control.errors[key][subkeys[0]]
        };
      }

      return {
        key: `i18n.validation.${key}`,
        translate: true,
        params: control.errors[key]
      };
    });
  }

  getApiErrorCode(error: any): string {
    if (error && error.response) {
      try {
        const errorObject = JSON.parse(error.response);
        if (errorObject.ErrorCode) {
          return errorObject.ErrorCode;
        }
      }
      catch { }
    }
    return null;
  }
}
